import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class NavigationHistoryService {
  private previousUrl = '/';
  private currentUrl = '/';

  constructor(private router: Router) {
    // 1) initiale URL unmittelbar nach App-Start
    this.currentUrl = this.router.url;

    // 2) jede Navigation mitschneiden
    this.router.events
      .pipe(filter((ev) => ev instanceof NavigationEnd))
      .subscribe((ev: NavigationEnd) => {
        this.previousUrl = this.currentUrl;
        this.currentUrl = ev.urlAfterRedirects;
      });
  }

  getPreviousUrl(): string {
    return this.previousUrl;
  }
}
